import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import axios from 'axios';
import AlertWithUrl from './AlertWithUrl';

import {
    catastropheBondsFactoryAddress_Fuji,
    catastropheBondsFactoryAddress_Amoy,
    catastropheBondsCollateralPoolAddress_Fuji,
    catastropheBondsCollateralPoolAddress_Amoy,
    chainSelector_Fuji,
    chainSelector_Amoy
} from "../config/config.js";

import catastropheBondsFactoryAbi from "../config/abis/catastropheBondsFactory.json";

const catastropheBondsFactoryContractInterface = ethers.Interface.from(catastropheBondsFactoryAbi);

const rootUrl = "https://europe-west3-shamba-staging-environment.cloudfunctions.net/cat-bonds-api-test"



function Bonds() {
    // State variables to store form inputs
    const [amount, setAmount] = useState(0);
    const [locations, setLocations] = useState([]);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [catastrophes, setCatastrophes] = useState([]);
    const [selectedCatastrophe, setSelectedCatastrophe] = useState('');

    const [isDeploying, setIsDeploying] = useState(false);
    const [txSuccess, setTxSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [messageId, setMessageId] = useState('');

    const currentDate = new Date();
    const oneYearAgo = new Date(currentDate.setFullYear(currentDate.getFullYear() - 1)).toISOString().slice(0, 10);

    const [startDate, setStartDate] = useState(oneYearAgo);
    const [endDate, setEndDate] = useState('');
    const [range, setRange] = useState('');

    const handleLocationChange = (e) => {
        setSelectedLocation(e.target.value);
    };
    const handleCatastropheChange = (e) => {
        setSelectedCatastrophe(e.target.value);
    };

    const handleRangeChange = (e) => {
        const selectedRange = e.target.value;
        setRange(selectedRange);

        const date = new Date(startDate);
        let endDate;

        switch (selectedRange) {
            case '10days':
                endDate = new Date(date.setDate(date.getDate() + 10));
                break;
            case '1month':
                endDate = new Date(date.setMonth(date.getMonth() + 1));
                break;
            case '3months':
                endDate = new Date(date.setMonth(date.getMonth() + 3));
                break;
            // case '6months':
            //     endDate = new Date(date.setMonth(date.getMonth() + 6));
            //     break;
            default:
                endDate = '';
        }

        if (endDate) {
            setEndDate(endDate.toISOString().slice(0, 10));
        } else {
            setEndDate('');
        }
    };

    const handleStartDateChange = (e) => {
        const newStartDate = e.target.value;
        setStartDate(newStartDate);

        // Recalculate the end date based on the new start date and the selected range
        if (range) {
            handleRangeChange({ target: { value: range } });
        }
    };

    async function deployCatastropheBond(catastropheCode, location, startDate_Timestamp, endDate_Timestamp, collateralRequiredForMintingAnyPositionToken) {
        try {
            setIsDeploying(true);
            const provider = new ethers.BrowserProvider(window.ethereum);

            const signer = await provider.getSigner();

            const chainId = parseInt((await provider.getNetwork()).chainId.toString());

            let catastropheBondsFactoryContract;
            let receiverChainDetails;
            let catastropheBondsCollateralPoolAddress;
            let networkName;

            if (chainId == 43113) {
                networkName = "Avalanche Fuji";
                catastropheBondsFactoryContract = new ethers.Contract(catastropheBondsFactoryAddress_Fuji, catastropheBondsFactoryAbi, signer);
                receiverChainDetails = {
                    catastropheBondsFactory: catastropheBondsFactoryAddress_Amoy,
                    collateralPool: catastropheBondsCollateralPoolAddress_Amoy,
                    chainSelector: chainSelector_Amoy
                };
                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Fuji;
            }

            else if (chainId == 80002) {
                networkName = "Polygon Amoy";
                catastropheBondsFactoryContract = new ethers.Contract(catastropheBondsFactoryAddress_Amoy, catastropheBondsFactoryAbi, signer);
                receiverChainDetails = {
                    catastropheBondsFactory: catastropheBondsFactoryAddress_Fuji,
                    collateralPool: catastropheBondsCollateralPoolAddress_Fuji,
                    chainSelector: chainSelector_Fuji
                };
                catastropheBondsCollateralPoolAddress = catastropheBondsCollateralPoolAddress_Amoy;
            }

            else {
                alert("Network not supported")
                setIsDeploying(false);
                return;
            }

            const tx = await catastropheBondsFactoryContract.createCatastropheBond(catastropheBondsCollateralPoolAddress, catastropheCode, location, startDate_Timestamp, endDate_Timestamp, collateralRequiredForMintingAnyPositionToken, false, receiverChainDetails);

            const rc = await tx.wait();

            let messageId;
            let catastropheBondAddress;
            let creationMessage;

            rc.logs.forEach(log => {

                const parsedLog = catastropheBondsFactoryContractInterface.parseLog(log);

                if (parsedLog) {
                    if (parsedLog.name == "MessageSent")
                        messageId = parsedLog.args[0];
                    else if (parsedLog.name == "CatastropheBondCreated") {
                        catastropheBondAddress = parsedLog.args[0];
                        creationMessage = `Your Catastrophe Bond is successfully created at ${catastropheBondAddress} on ${networkName} network.\n\n`
                    }
                }
            });

            if (messageId && creationMessage) {
                setTxSuccess(true);
                setMessage(creationMessage);
                setMessageId(messageId);
                setIsDeploying(false);
            }

            // console.log(`Your Catastrophe Bond is successful created at ${catastropheBondAddress} on Avalanche Fuji network.\n\nPlease visit https://ccip.chain.link/msg/${messageId} to check the cross-chain creation status of your Catastrophe Bond.`)
        }
        catch (error) {
            setIsDeploying(false);
            try {
                const revertData = error.data
                const decodedError = catastropheBondsFactoryContractInterface.parseError(revertData)
                if (decodedError) {
                    if (decodedError.name == 'CatastropheBondsFactory__NotFundedWithEnoughLINK')
                        alert(`Transaction failed: Please fund the CatastropheBondsFactory contract at ${catastropheBondsFactoryAddress_Fuji} with at least ${parseFloat(ethers.formatUnits(decodedError.args[0]))} LINK token.`);
                    else
                        console.error(decodedError.name);
                }
                else {
                    console.log("Transaction failed: Unknown error.");
                }
            }

            catch (error) {
                console.log("Error inside the 1st catch...")
                console.error(error.toString());
                console.log("Transaction failed: Unknown error.");
            }
        }
    }

    async function createCatastropheBond() {
        // console.log("here")
        // console.log(selectedCatastrophe, selectedLocation, startDate, endDate, amount);
        // Get the epoch timestamp in milliseconds
        let epochMilliseconds_startDate = new Date(startDate).getTime();

        // Convert milliseconds to seconds
        let epochSeconds_startDate = Math.floor(epochMilliseconds_startDate / 1000);
        // console.log(epochSeconds_startDate);

        // Get the epoch timestamp in milliseconds
        let epochMilliseconds_endDate = new Date(endDate).getTime();

        // Convert milliseconds to seconds
        let epochSeconds_endDate = Math.floor(epochMilliseconds_endDate / 1000);
        // console.log(epochSeconds_endDate);

        await deployCatastropheBond(selectedCatastrophe, selectedLocation, epochSeconds_startDate, epochSeconds_endDate, ethers.parseUnits(amount.toString(), 6));

    }

    // Handler for form submission
    const handleFormSubmit = async (event) => {
        event.preventDefault();
        await createCatastropheBond();
    };

    useEffect(() => {
        const fetchCatastrophes = async () => {
            try {
                const response = await axios.get(`${rootUrl}/getCatastrophes`);
                setCatastrophes(response.data.data);
            } catch (error) {
                console.error('Error fetching the catastrophes:', error);
            }
        };

        const fetchLocations = async () => {
            try {
                const response = await axios.get(`${rootUrl}/getLocations`);
                setLocations(response.data.data);
            } catch (error) {
                console.error('Error fetching the locations:', error);
            }
        };

        fetchCatastrophes();
        fetchLocations();
    }, []);

    return (
        <div>
            {txSuccess && <AlertWithUrl message={message} messageId={messageId} typeOfMessage="creation" target="Catastrophe Bond" onClose={() => setTxSuccess(false)} />}
            <div className="row">
                <div className="col-md-12 grid-margin stretch-card">
                    <div className="card">
                        <div className="card-body">
                            <div className="d-flex flex-row justify-content-between">

                            </div>

                            <div className="row">
                                <div className="col-12">
                                    <div className="card">
                                        <div className="card-body">
                                            <h4 className="card-title">Create Bonds</h4>
                                            <form class="forms-sample" onSubmit={handleFormSubmit}>

                                                <div class="form-group">
                                                    <label>Location:</label>
                                                    <select onChange={handleLocationChange} className="form-control" value={selectedLocation}>
                                                        <option value="">Select a location</option>
                                                        {locations.map(location => (
                                                            <option key={location} value={location}>{location}</option>
                                                        ))}
                                                    </select>
                                                </div>

                                                <div class="form-group">
                                                    <label>Catastrophe:</label>
                                                    <select onChange={handleCatastropheChange} className="form-control" value={selectedCatastrophe}>
                                                        <option value="">Select a catastrophe</option>
                                                        {catastrophes.map(catastrophe => (
                                                            <option key={catastrophe.key} value={catastrophe.key}>{catastrophe.value}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Start Date:</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={startDate}
                                                        onChange={handleStartDateChange}
                                                        readOnly
                                                        style={{
                                                            backgroundColor: '#333',
                                                            color: '#44bd44',
                                                            opacity: 1
                                                        }}
                                                    />
                                                </div>
                                                <div className="form-group">
                                                    <label>Bond Duration:</label>
                                                    <select className="form-control" value={range} onChange={handleRangeChange} required>
                                                        <option value="">Select Duration</option>
                                                        <option value="10days">10 Days</option>
                                                        <option value="1month">1 Month</option>
                                                        <option value="3months">3 Months</option>
                                                        {/* <option value="6months">6 Months</option> */}
                                                    </select>
                                                </div>
                                                <div className="form-group">
                                                    <label>Maturity Date:</label>
                                                    <input
                                                        type="date"
                                                        className="form-control"
                                                        value={endDate}
                                                        readOnly
                                                        style={{
                                                            backgroundColor: '#333',
                                                            color: '#44bd44',
                                                            opacity: 1
                                                        }}
                                                    />
                                                </div>
                                                <div class="form-group">
                                                    <label>Collateral Amount (in USDC):</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        placeholder="Enter Collateral Amount (in USDC)"
                                                        value={amount}
                                                        onChange={(e) => setAmount(e.target.value)}
                                                        required
                                                    />
                                                </div>



                                                {isDeploying ? <p>Deploying...</p> : <button type="submit" className='btn btn-primary mr-2'>Deploy</button>}

                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    );
}

export default Bonds;
